import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import Broker from 'bundles/apex/deals/show/brokers/broker';
import ContactDetails from 'bundles/backoffice/contacts/details';
import ContactIcon from 'bundles/backoffice/contacts/icon';
import ContactFormModalLink from 'bundles/apex/deals/show/contacts/contact/contact_form_modal_link';
import Row from './row';
import { getBrokerageGrossCommissionAmount } from './helpers';
import { filterCommissions } from 'bundles/backoffice/vouchers/helpers/commissions';
import { USD } from 'helpers/formatters/number_formats';

export function TransactionSideCardOutsideCommissions({ deal, transactionSide }) {
  const commissions = filterCommissions(deal.commissions, transactionSide, true);
  if (!commissions.length) {
    return null;
  }

  return <React.Fragment>
    <b className="mb-3">Outside Brokers</b>
    {commissions.map((commission, i) => (
      <Broker
        commission={commission}
        deletable
        icon={<ContactIcon contact={commission.contact} />}
        index={i}
        justify={false}
        key={i}
        transactionSide={transactionSide}
      >
        <ContactDetails
          contact={commission.contact}
          formModalLinkComponent={ContactFormModalLink}
          label={false}
        />
      </Broker>
    ))}

    <div className="mt-3">
      <Row
        borderBottom
        borderTop
        label="Brokerage Gross"
        value={USD.format(getBrokerageGrossCommissionAmount(deal, transactionSide))}
      />
    </div>
  </React.Fragment>;
}

TransactionSideCardOutsideCommissions.propTypes = {
  deal: PropTypes.shape({
    commissions: PropTypes.array.isRequired,
  }).isRequired,
  transactionSide: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  deal: state.deal,
});

export default connect(mapStateToProps)(TransactionSideCardOutsideCommissions);
